import { jsx as r } from "react/jsx-runtime";
import { QueryClientProvider as t, QueryClient as n } from "@tanstack/react-query";
const i = new n({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchInterval: !1,
      refetchOnWindowFocus: !1,
      refetchOnMount: !1,
      refetchIntervalInBackground: !1
    }
  }
});
function f({ children: e }) {
  return /* @__PURE__ */ r(t, { client: i, children: e });
}
export {
  f as QueryClientProvider
};
